<mat-expansion-panel [expanded]="true">
  <mat-expansion-panel-header>
    <mat-panel-title>
      Connections Info and Data Usage (<span class="billing-note">Note: Billing is done in UTC+00:00</span>)
    </mat-panel-title>
  </mat-expansion-panel-header>
  <p class="usage-source" *ngIf="hasCumulativeUsage">Usage shows cumulative counters from the latest device telemetry, matching Diagnostics. Analytics time-range selections apply to the charts.</p>
  <div class="connections-scroll" tabindex="0" role="region" aria-label="Connections Info and Data Usage">
    <table>
      <thead>
        <tr>
          <th scope="col">Zone</th><th scope="col">State</th><th scope="col">SDWAN</th>
          <th scope="col">Type</th><th scope="col">Network</th><th scope="col">Device</th>
          <th scope="col">Protocol</th><th scope="col">MAC</th><th scope="col">Address</th>
          <th scope="col">External IP</th><th scope="col">ISP</th><th scope="col">Action</th>
          <th scope="col">Uptime</th><th scope="col">Usage</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of rows" [class.connection-detail]="row.detail" [class.group-start]="!row.detail">
          <td [class.zone-wan]="row.zone === 'wan'" [class.zone-lan]="row.zone === 'lan'" [class.zone-ras]="row.zone === 'ras'">{{row.zone}}</td>
          <td><span [class.state-up]="row.state === 'Up'" [class.state-inactive]="row.state !== 'Up'">{{row.state}}</span></td>
          <td>{{row.sdwan}}</td><td>{{row.type}}</td><td>{{row.network}}</td><td>{{row.device}}</td><td>{{row.protocol}}</td>
          <ng-container *ngIf="!row.detail">
            <td class="mac">{{row.mac}}</td><td>{{row.address}}</td><td>{{row.externalIp}}</td><td>{{row.isp}}</td>
          </ng-container>
          <td *ngIf="row.detail" colspan="4">{{row.metrics}}</td>
          <td>{{row.action}}</td><td class="nowrap">{{row.uptime}}</td><td class="nowrap">{{usage(row)}}</td>
        </tr>
        <tr *ngIf="!rows.length"><td colspan="14">No connection data available.</td></tr>
      </tbody>
      <tfoot><tr><th scope="row">Total</th><td *ngFor="let column of [1,2,3,4,5,6,7,8,9,10,11,12]"></td><td class="nowrap">{{total()}}</td></tr></tfoot>
    </table>
  </div>
</mat-expansion-panel>
<div class="mt-4" *ngIf="is_oldfirmware">To add this device to Monitor server, click <a class="btn-here" (click)="editDevice()">here.</a></div>
